import { render } from "./TopMenu.vue?vue&type=template&id=2dd6bfa3&ts=true"
import script from "./TopMenu.ts?vue&type=script&lang=ts&external"
export * from "./TopMenu.ts?vue&type=script&lang=ts&external"

import "./TopMenu.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
